import React from "react";
import { StyledDashBoardContainer, StyledTiles } from "./styles";
import DashBoardTile from "./DashBoardTile";
import { translate } from "../../utils/translations/translate";
import { WeekPicker } from "../DatePicker/WeekPicker";
import { DOWNLOAD_OPTIONS } from "../../utils/constants";
import { Popupmenu } from "../UI/PopupMenu";
import { Loader } from "../Loader/Loader";
import { useEmployerDashboard } from "./hooks/useEmployerDashboard";
import { Alert } from "../UI/Alert";
import { DashboardReportModal } from "./DashboardReportModal";
const EmployerDashBoard = () => {
  const {
    TILES_DATA,
    handleWeekChange,
    isLoading,
    handleTileClick,
    onModalClose,
    reportData,
    showReportModal,
    toastInfo,
    handleToastClose,
    onExcelReportClick,
    modalTitle,
    selectedWeek,
    downloadCurrentModalReport,
  } = useEmployerDashboard();
  return (
    <StyledDashBoardContainer className="tma_dashboard_container">
      {toastInfo && <Alert {...toastInfo} onToastClose={handleToastClose} />}
      <header className="tma_dashboard_header">
        <h1>{translate("pageTitles.adminDashboard")}</h1>
        <div className="tma_dashboard_actions">
          <Popupmenu
            label={translate("labels.moreOptions")}
            popupOptions={DOWNLOAD_OPTIONS.slice(0, 1)}
            variantstyle="secondary"
            className="tma_employer_popup"
            onOptionSelect={({ key }) => {
              if (key === "excel") {
                onExcelReportClick();
              }
            }}
          />
          <WeekPicker onChange={handleWeekChange} disableFuture={true} />
        </div>
      </header>
      <StyledTiles>
        {TILES_DATA.map((tile_info, index) => {
          return (
            <div className="tma_dashboard_row" key={index}>
              {tile_info.map((tile, idx) => {
                return (
                  <DashBoardTile
                    key={idx}
                    title={tile.title}
                    variant={tile.variant}
                    text={tile.text}
                    isClickable={tile.isClickable}
                    onTileClick={handleTileClick}
                  />
                );
              })}
            </div>
          );
        })}
      </StyledTiles>
      {isLoading && <Loader />}
      {showReportModal && <DashboardReportModal onDownload={downloadCurrentModalReport} selectedweek={selectedWeek} reportData={reportData} filter={modalTitle.current} onClose={onModalClose} />}
    </StyledDashBoardContainer>
  );
};

export default EmployerDashBoard;
